/**
 * Store changes the bridge streams on `GET /api/events` (SSE, event name
 * `store`), see docs/device-state-deltas.md.
 *
 * Per device (`id` = connection id) a client first gets a snapshot, then
 * deltas. A delta applies when its `epoch` matches and its `revision` is the
 * client's revision + 1; a new epoch always arrives as a snapshot.
 */
/** SSE event name of store events */
export const DEVICE_STORE_EVENT = "store";
